import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_CONTACT_CATEGORIES = `${ACCOUNT_SERVICE}/contact-categories`;

export const contactCategories = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_CONTACT_CATEGORIES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getByType: async ({ type, filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_CONTACT_CATEGORIES}/${type}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  delete: async ({ type, label, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_CONTACT_CATEGORIES}/${type}/${label}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
  create: async ({ type, label, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_CONTACT_CATEGORIES}/${type}/${label}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ type, label, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_CONTACT_CATEGORIES}/${type}/${label}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
